<div class="buttons pa-20">
  <button (click)="openExpedientActionsModal('0')" class="btn-cancel" shape="round" >Efetuar Despacho</button>
  <div class="solid"></div>
  <button (click)="openExpedientActionsModal('0')"  class="btn-cancel" shape="round" >Solicitar Parecer</button>
  <button *ngIf="!p.userRole(['PR']) && !p.userPermission([p.permissionList.Gabinete.pr_tasks])" (click)="openExpedientActionsModal('2')" class="btn-cancel" shape="round" >Pedido de Deferimento</button>
  <button (click)="openBookMeetingModal()" class="btn-cancel" shape="round" >Marcar Reunião</button>
</div>